<template>
  <div class="card mb-3">
    <div class="card-header bg-light">
      <h5 class="mb-0">Datos sobre perceptor/a</h5>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-lg-6">
          <div class="form-group">
            <label for="dni">NIF/CIF</label>
            <input
              :value="localResume.dni"
              @input="$emit('update:field', 'dni', $event.target.value)"
              type="text"
              class="form-control"
              id="dni"
              placeholder="NIF/CIF del perceptor"
            />
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label for="name">Nombre o razón social</label>
            <input
              :value="localResume.name"
              @input="$emit('update:field', 'name', $event.target.value)"
              type="text"
              class="form-control"
              id="name"
              placeholder="Nombre completo o razón social del perceptor"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PerceptorSection",
  props: {
    localResume: {
      type: Object,
      required: true,
    },
  },
};
</script>
